import { useState } from "react";
import { Field, Label, Switch } from "@headlessui/react";
import { PhotoIcon } from "@heroicons/react/24/outline";
import { EditUserViewModel, useUpdateUserAvatarSettingForUserMutation } from "../../usersApiSlice";

interface UserAvatarProps {
	userInfo: EditUserViewModel;
	setErrorMessage: (message: string) => void;
}

export default function UserAvatarSetting(props: UserAvatarProps) {
	const [avatarsEnabled, setAvatarsEnabled] = useState(props.userInfo.allowUserImages);
	const [disabledBy, setDisabledBy] = useState(props.userInfo.userImageDisabledBy);

	const [updateAvatarSetting] = useUpdateUserAvatarSettingForUserMutation();

	function handleAvatarChange() {
		updateAvatarSetting({ userId: props.userInfo.id, allowImages: !avatarsEnabled })
			.unwrap()
			.then(() => {
				setAvatarsEnabled(!avatarsEnabled);
				setDisabledBy("");
				props.setErrorMessage("");
			})
			.catch((error) => {
				scrollTo(0, 0);
				props.setErrorMessage(`Failed to save the user avatar setting. ${error.data}`);
			});
	}

	return (
		<div className="flex items-center">
			<PhotoIcon className="size-18 shrink-0" />
			<div className="ml-4">
				<p>Allow User Avatars</p>
				<Field className="flex items-center mt-1 ml-2">
					<Label className="sr-only">User Avatar Toggle</Label>
					<Switch
						checked={avatarsEnabled}
						onChange={handleAvatarChange}
						name="userAvatar"
						className="group relative inline-flex h-7 w-12 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-primary-600 focus:ring-offset-2 data-[checked]:bg-primary-600">
						<span
							aria-hidden="true"
							className="pointer-events-none inline-block size-6 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
						/>
					</Switch>
					{disabledBy && (
						<p className="ml-2 text-sm break-words">Disabled by: {disabledBy}</p>
					)}
				</Field>
			</div>
		</div>
	);
}
